import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import TimeTrackingPayPeriod from './TimeTrackingPayPeriod';
import moment from 'moment';
import _ from 'lodash';

class TimeTrackingPaySchedule extends DomainObject {
  name;
  frequency;
  readOnly;
  payPeriods = [];
  currentPayPeriod;
  latestPayPeriod;

  _relations = {
    payPeriods: [TimeTrackingPayPeriod],
    currentPayPeriod: TimeTrackingPayPeriod,
    latestPayPeriod: TimeTrackingPayPeriod
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      frequency: observable,
      readOnly: observable,
      payPeriods: observable,
      currentPayPeriod: observable,
      latestPayPeriod: observable,
      sortedPayPeriods: computed,
      previousPayPeriod: computed
    });

    this.merge(other);
  }

  get sortedPayPeriods() {
    return _.orderBy(this.payPeriods, 'startDate', 'desc');
  }

  get previousPayPeriod() {
    return _.find(this.sortedPayPeriods, payPeriod => moment(payPeriod.endDate).isBefore(moment())) ||
      _.find(this.sortedPayPeriods, payPeriod => moment(payPeriod.startDate).isBefore(moment())) ||
      this.sortedPayPeriods[0];
  }
}

export default TimeTrackingPaySchedule;
